export const MARKER_COLORS = {
    MARKETPLACE_PICKUP: '#187522',
    MARKETPLACE_DROPOFF: '#59b863',
    SUPPLY_PICKUP: '#191970',
    SUPPLY_DROPOFF: '#4a4ae0',
    NEARBY_ROUTE: '#A54DFD',
    SELECTED_ROUTE: '#FF903D',
};
